const createPrescription = savedWorkoutSetExercise => {
    const prescription = {
        id: 0,
        custom: 1,
        title: 'Custom',
        tags: [],
        param_1_type: savedWorkoutSetExercise.param1Type,
        param_2_type: savedWorkoutSetExercise.param2Type,
        param_1_data_1: savedWorkoutSetExercise.param1Data1,
        param_1_data_2: savedWorkoutSetExercise.param1Data2
    };
    let numberOfSets = 10;
    for (let setNumber = 1; setNumber < 11; setNumber++) {
        const param1Key = `param1Data${setNumber}`;
        const param2Key = `param2Data${setNumber}`;
        if (
            !savedWorkoutSetExercise[param1Key] &&
            !savedWorkoutSetExercise[param2Key]
        ) {
            numberOfSets = setNumber - 1;
            break;
        }
        prescription[`param_1_data_${setNumber}`] =
            savedWorkoutSetExercise[param1Key];
        prescription[`param_2_data_${setNumber}`] =
            savedWorkoutSetExercise[param2Key];
    }
    prescription.param_count = numberOfSets;
    return prescription;
};

const LastPerformanceBO = {
    createPrescription
};

export default LastPerformanceBO;



// WEBPACK FOOTER //
// ./src/v5/LastPerformance/businessObjects/LastPerformanceBO.js